
if (typeof elementInView == 'undefined') {

	// Get animatable scroll elements
	var scrollElements = Array.prototype.slice.call(document.querySelectorAll('[data-scroll], .data-scroll'));

	// Get load on scroll elements
	var loadHandlers = Array.prototype.slice.call(document.querySelectorAll('[data-unloaded], .data-unloaded'));

	// Create full node list
	scrollElements.push.apply(scrollElements, loadHandlers);

	// Check if element is in view
	const elementInView = (el, dividend = 1) => {
		const elementTop = el.getBoundingClientRect().top;

		return (
			elementTop <=
			(window.innerHeight || document.documentElement.clientHeight) / dividend
		);
	};

	// Check if out of view
	const elementOutofView = (el) => {
		const elementTop = el.getBoundingClientRect().top;

		return (
			elementTop > (window.innerHeight || document.documentElement.clientHeight)
		);
	};

	// In view add .scrolled class
	// remove data-unloaded from load elements
	const displayScrollElement = (element) => {
		element.classList.add("scrolled");
		if (element.dataset.unloaded) {
			element.src = element.dataset.src;
			delete element.dataset.unloaded
		}
	};

	// Remove .scrolled class when off screen
	const hideScrollElement = (element) => {
		element.classList.remove("scrolled");
	};


	// Loop scroll elements array checking conditions
	const handleScrollAnimation = () => {
		scrollElements.forEach((el) => {
			if (elementInView(el, 1.25)) {
				displayScrollElement(el);
			} else if (elementOutofView(el)) {
				hideScrollElement(el)
			}
		})
	}

	// On scroll event
	window.addEventListener("scroll", () => {
		handleScrollAnimation();
	});
	// Also check on load
	handleScrollAnimation();

}